import "./Headings.scss";

export function ModalHeading({ children }: { children: React.ReactNode }) {
  return <div className="modal-heading">{children}</div>;
}
